import { MStaticClient, MStaticFilter, MStaticInter } from '@argalis-apps/models';

export const TEST_ISTATICInterInfo: MStaticInter.IStaticInterInfo = {
  ca: {
    prixGlobal: 10530,
    prixRessource: 0
  },
  marge: 10362,
  pourcentCA: 98,
  produitsEncadres: [
    {
      nb_produits: '29'
    }
  ],
  dataApp: {
    nbApp: 30,
    taux: 50
  },
  nbSession: [
    {
      coalesce: '6'
    }
  ],
  totalHeure: [
    {
      heure: {
        hours: 84
      }
    }
  ],
  totalJour: [
    {
      jour: 12
    }
  ],
  totalHeureBPF: [
    {
      heure: {
        hours: 406
      }
    }
  ],
  satisfaction: [
    {
      satisfaction: 84.869696969697
    }
  ],
  infoCoutTotalInterv: [
    {
      id: 143,
      cout_pedagogique: 168,
      cout_deplacement: 0,
      cout_hotel: 0,
      cout_repas: 0,
      cout_materiel: '0'
    }
  ],
  coutTotalInterv: 168,
  trajetInterv: [
    {
      id: 143,
      distance_totale: 7625.42,
      temps_de_trajet: 127.090299479167
    }
  ],
  indispoInterv: [
    {
      date_debut: '06/12/2018 21:00:00',
      date_fin: '07/12/2018 20:30:00',
      libelle: 'Prépa'
    },
    {
      date_debut: '04/12/2018 21:00:00',
      date_fin: '05/12/2018 20:30:00',
      libelle: 'Prépa'
    }
  ]
};

export const TEST_visualtionInter: MStaticInter.IStatistiqueCardVisualisationInter = {
  ca: true,
  stagiare: true,
  session: true,
  marge: true,
  satisfaction: true,
  produit_encadre: true,
  cout_intervenant: true,
  indisponibilite: true,
  deplacement: true
};
export const TEST_visualtionClient: MStaticClient.ICardVisualisationClient = {
  ca: true,
  stagiare: true,
  session: true,
  marge: true,
  satisfaction: true
};

export const TEST_IStaticClientInfo: MStaticClient.IStaticClientInfo = {
  ca: 2550,
  marge: 1255,
  pourcentCA: 49,
  dataApp: {
    nbApp: 10,
    taux: 100
  },
  nbAbsent: [
    {
      nb_absents: '0'
    }
  ],
  nbSession: [
    {
      coalesce: '1'
    }
  ],
  datesSession: [
    {
      dates: 3
    }
  ],
  totalHeure: [
    {
      heure: {
        hours: 21
      }
    }
  ],
  totalJour: [
    {
      jour: 3
    }
  ],
  totalHeureBPF: [
    {
      heure: {
        hours: 210
      }
    }
  ],
  satisfaction: [
    {
      satisfaction: 0
    }
  ]
};
